import EmptyResults from './EmptyResults'

export default EmptyResults
